export default function(url) { 
    const clearPathname = url.split("/").filter( (string) => string !== "");
    const newPath = `${clearPathname.slice(2).join('/')}`; 

    return newPath;
} 